/**
 * @module components\ghDataView
 */
import Vue from "vue";
import { Component, Prop, Provide, Watch } from "vue-property-decorator";
import { TableQueryService } from "../../utils/serviceModel";

@Component
export default class GhDataView extends Vue {
  @Prop() module!: string; // 模块
  @Prop() cls!: string; // 类名
  @Prop() method: string; // 方法
  @Prop() headers: ITableHeader[]; // 表头
  @Prop({ default: true }) paginateServer!: boolean;
  @Prop() args: {};

  service: any = {};
  selectedItems: object[] = [];
  totalItems: any = null;
  private items?: object[] = [];
  mounted() {
    this.service = new TableQueryService(this.module, this.cls, this.method);
    this.service.headers = this.headers;
    this.query();
  }

  private query() {
    this.service.args = this.args;
    this.service.invokeAsyn().finally(() => {
      if (this.paginateServer) {
        this.totalItems = this.service.data[0];
        this.items = this.service.data[1];
      } else {
        this.items = this.service.data;
      }
    });
  }

  @Watch("service.pagination")
  private emitPaginate() {
    if (this.paginateServer) {
      this.query();
    }
  }
}
